const story = () => {
    if ($(".relation-story").length) {
        $('.list-article').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $('#prev-article'),
            nextArrow: $('#next-article'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}

module.exports = story
